import React from 'react';
import { PageTitle } from '../../../common/components/page-title';
import { DATA_API } from '../../../common/constants/api';
import { DocsLayout } from '../../common/components/layout/docs-layout';

export const DocsPage = () => (
	<React.Fragment>
		<PageTitle
			title="Documentation"
			linkHref="/explorer"
			linkTitle="API Explorer"
		/>
		<DocsLayout>
			<h2 className="text-4xl mb-2">Getting Started</h2>

			<h3 className="text-2xl mt-8">Base URL</h3>
			{DATA_API}/

			<h3 className="text-2xl mt-10">Headers</h3>
			It is required to set <b>app-id</b> Header for each request.<br />
			It helps us to determine your personal environment.
			So only you can access data that were created or update.<br /><br />
			You can get personal App ID value on your account page.<br />
			You can have as much App ID as you want and use it
			in parallel(for different projects, envs etc).<br /><br />
			<b>Example:</b> app-id: 0JyYiOQXQQr5H9OEn21312

			<h3 className="text-2xl mt-10">Paging</h3>

			For some endpoints you will get a single item. But for some of them it should be a list of objects.<br />
			To control amount of items, you need to use <b>page</b> and <b>limit</b> URL params.<br />
			<b>Limit</b> value should be in range <b>[5-50]</b>. Default value: 20<br />
			<b>Page</b> value should be in range <b>[0-999]</b>. Default value: 0<br /><br />
			<b>Example:</b> {DATA_API}/user?page=1&limit=10<br />
			Take 10 elements on a second page(page number starts from zero). Return items from 11 to 20 in a default order.

			<h3 className="text-2xl mt-10">Created</h3>
			In case you want to get only items created in current environment(exclude base items).<br />
			Use created <b>query</b> parameter - <b>created=1</b>.<br /><br />
			<b>Example:</b> {DATA_API}/user?created=1<br />

		</DocsLayout>
	</React.Fragment>
);
